<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 21 21">
    <path
      d="M0.5 10.5H20.5M0.5 10.5C0.5 16.0228 4.97715 20.5 10.5 20.5M0.5 10.5C0.5 4.97715 4.97715 0.5 10.5 0.5M20.5 10.5C20.5 16.0228 16.0228 20.5 10.5 20.5M20.5 10.5C20.5 4.97715 16.0228 0.5 10.5 0.5M10.5 0.5C13.0013 3.23835 14.4228 6.79203 14.5 10.5C14.4228 14.208 13.0013 17.7616 10.5 20.5M10.5 0.5C7.99872 3.23835 6.57725 6.79203 6.5 10.5C6.57725 14.208 7.99872 17.7616 10.5 20.5"
      :class="colorClass"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
